import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { DataGridModule } from '../data-grid/data-grid.module';
import { ThemeEmitterModule } from '../theme-emitter/theme-emitter.module';
import { ListComponent } from './list.component';

@NgModule({
    declarations: [
        ListComponent,
    ],
    imports     : [
      CommonModule,
      MatDividerModule,
      MatToolbarModule,
      MatButtonModule,
      MatIconModule,
        MatTooltipModule,
        FuseSharedModule,
        DataGridModule,
        ThemeEmitterModule,
        PhoenixDirectivesModule,
    ],
    exports     : [
        ListComponent,
    ],
})
export class ListModule{}
